import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { ShopTypeEnum } from 'components/AuthShop/components/ShopeeCNSCGuide';
import { useChatDiversionDialog } from 'components/ChatDiversionDialog/useChatDiversionDialog';
import { LocalMessage } from 'hooks/business/conversation';
import { useGetConversationById } from 'hooks/business/lruConversation';
import { useMemo } from 'react';

export const ShopeeChatDiversion = (props: { message: LocalMessage }) => {
  const { message } = props;
  const { conversationId } = message;
  const { t } = useTranslate();
  const { show: showChatDiversionDialog } = useChatDiversionDialog();
  const getConversation = useGetConversationById();

  const storeType = useMemo(() => {
    const conversation = getConversation(conversationId);
    const styleType = conversation?.topBarInfo?.storeType;
    return styleType;
  }, [conversationId, getConversation]);

  return (
    <div className="bg-[#FFD6D6] rounded px-2 py-1 mt-1">
      <span className="text-[#515359]">{t('sendMsgFail.closeChatAssign')}</span>
      <Button
        className="!pl-2 !pr-0"
        type="link"
        size="small"
        onClick={() =>
          showChatDiversionDialog(
            storeType === 'LOCAL' ? ShopTypeEnum.Local : ShopTypeEnum.CrossOfficial,
          )
        }
      >
        {t('feedback.查看详情')}
      </Button>
    </div>
  );
};
